"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconProcess = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconProcess = function SvgIconProcess(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0.999999C6.52454 0.999999 6.95475 0.596137 6.99665 0.0823975C9.51186 0.502902 11.4971 2.48814 11.9176 5.00335C11.4039 5.04525 11 5.47546 11 6C11 6.52454 11.4039 6.95475 11.9176 6.99665C11.4971 9.51186 9.51186 11.4971 6.99665 11.9176C6.95475 11.4039 6.52454 11 6 11C5.47546 11 5.04525 11.4039 5.00335 11.9176C2.48814 11.4971 0.502902 9.51186 0.0823975 6.99665C0.596137 6.95475 1 6.52454 1 6C1 5.47546 0.596137 5.04525 0.0823975 5.00335C0.502902 2.48814 2.48814 0.502902 5.00335 0.0823975C5.04525 0.596137 5.47546 0.999999 6 0.999999ZM6.75 3C6.75 2.58579 6.41421 2.25 6 2.25C5.58579 2.25 5.25 2.58579 5.25 3V6C5.25 6.19891 5.32902 6.38968 5.46967 6.53033L7.46967 8.53033C7.76256 8.82322 8.23744 8.82322 8.53033 8.53033C8.82322 8.23744 8.82322 7.76256 8.53033 7.46967L6.75 5.68934V3Z",
    fill: "currentColor"
  }));
};

exports.SvgIconProcess = SvgIconProcess;